/**
 * carousel.js — Wrap-around carousel for TFD
 * Uses native scroll with seamless looping via cloned bookend items.
 * No external dependencies.
 */

(function () {
  'use strict';

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  function initCarousel(el) {
    var track = el.querySelector('[data-carousel-track]');
    if (!track) return;

    var prevBtn = el.querySelector('[data-carousel-prev]');
    var nextBtn = el.querySelector('[data-carousel-next]');

    function getScrollAmount() {
      var firstCard = track.querySelector('.product-card');
      if (!firstCard) return track.clientWidth * 0.8;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return firstCard.offsetWidth + gap;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    // --- Infinite wrap-around ---
    var items = Array.from(track.children);
    if (items.length < 2) return;

    // Clone a screenful of items at each end for the loop illusion
    var visibleCount = Math.ceil(track.clientWidth / (items[0].offsetWidth || 200)) + 1;
    var cloneCount = Math.min(visibleCount, items.length);

    // Append clones of the first items
    for (var i = 0; i < cloneCount; i++) {
      var clone = items[i].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    // Prepend clones of the last items
    for (var j = items.length - 1; j >= items.length - cloneCount; j--) {
      var clone2 = items[j].cloneNode(true);
      clone2.setAttribute('aria-hidden', 'true');
      track.insertBefore(clone2, track.firstChild);
    }

    // Set initial scroll to skip prepended clones
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    var prependWidth = 0;
    for (var k = 0; k < cloneCount; k++) {
      prependWidth += track.children[k].offsetWidth + gap;
    }
    track.scrollLeft = prependWidth;

    // Watch for scroll hitting clone regions, jump back seamlessly
    var jumping = false;
    track.addEventListener('scroll', function () {
      if (jumping) return;

      var totalOrigWidth = 0;
      for (var m = 0; m < items.length; m++) {
        totalOrigWidth += items[m].offsetWidth + gap;
      }

      if (track.scrollLeft <= gap) {
        jumping = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft += totalOrigWidth;
        track.style.scrollBehavior = '';
        jumping = false;
      } else if (track.scrollLeft >= prependWidth + totalOrigWidth - gap) {
        jumping = true;
        track.style.scrollBehavior = 'auto';
        track.scrollLeft -= totalOrigWidth;
        track.style.scrollBehavior = '';
        jumping = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();
